import { Scissors } from 'lucide-react';
import { Link } from 'react-router-dom';

import { formatPageRange } from './pageRange';

interface SegmentChipProps {
  parentJobId: string;
  segmentIndex: number | null;
  segmentLabel: string | null;
  startPage: number;
  endPage: number;
}

/**
 * Header chip shown when the open document is a segment of a split upload. States the
 * segment's ordinal, optional label and the pages it occupies in the original file, and
 * links back to the parent's «Documento dividido» page — the reverse of the navigation
 * the SplitChildrenPanel already offers (parent → child).
 */
export function SegmentChip({
  parentJobId,
  segmentIndex,
  segmentLabel,
  startPage,
  endPage,
}: SegmentChipProps): JSX.Element {
  const ordinal = segmentIndex !== null ? `Segmento ${segmentIndex + 1}` : 'Segmento';
  const label = segmentLabel !== null && segmentLabel.trim() !== '' ? ` · ${segmentLabel}` : '';
  const pages = ` · ${formatPageRange(startPage, endPage)}`;

  return (
    <Link
      to={`/documents/${encodeURIComponent(parentJobId)}`}
      title="Ver el documento original dividido"
      className="inline-flex items-center gap-1.5 rounded border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs text-slate-600 transition-colors hover:border-slate-300 hover:bg-slate-100 hover:text-slate-900"
    >
      <Scissors className="h-3 w-3" aria-hidden strokeWidth={2} />
      <span>{`${ordinal}${label}${pages}`}</span>
    </Link>
  );
}
